import moment from 'moment';

export default {
  props: {},
  data() {
    return {
      isEmailVerificationRequired: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    createUser() {
      const self = this;

      return axios
        .post(zRoute('register'), {
          email: this.form.email,
          password: this.form.password,
          cid: window.localStorage.getItem('campaign_cid'),
          eid: window.localStorage.getItem('campaign_eid'),
          campaign_query: window.localStorage.getItem('campaign_query'),
        })
        .then((response) => {
          if (response.data.status === 'success') {
            this.isEmailVerificationRequired = response.data.verification_is_required;
          }

          return response;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            if (!('email' in error.response.data.errors || 'password' in error.response.data.errors)) {
              self.$refs.form.setErrors({ 'email': error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] });
            } else {
              self.$refs.form.setErrors(error.response.data.errors);
            }
          }
        });
    },
    updateUser() {
      const self = this;

      return axios
        .put(zRoute('register.update'), self.getPreparedData())
        .then(function (response) {
          if (response.data.status === 'success') {

            self.$store.dispatch('analytics/gtagEvent', {
              event: 'doi',
              p: {
                'event_category': 'User Registration',
                'event_label': 'DOI Registration'
              }
            });
          } else {
            self.$refs.form.setErrors({ data: [self.trans.get('auth.card.data_update_failed')] });
          }
        })
        .catch((error) => {
          const errors = error.response.data.errors;
          if (error.response.status === 422) {
            self.$refs.form.setErrors({
              data: [
                errors[Object.keys(errors)[0]][0],
                self.trans.get('auth.card.data_update_failed')
              ]
            });
          }
          throw error;
        });
    },
    getPreparedData() {
      let preparedData = JSON.parse(JSON.stringify(this.form));
      preparedData.birth_date = moment(this.form.birth_date, 'DD MM YYYY').format('YYYY-MM-DD');

      return preparedData;
    }

  },
  mounted() {
  },
  activated() {

  },
  deactivated() {

  }
}
